import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const AuthCheck = ({ children }) => {
  const [isVerifying, setIsVerifying] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuth = () => {
      const token = localStorage.getItem("u_token");
      const role = Number(localStorage.getItem("role_code"));

      if (token && role) {
        if (role === 1) {
          navigate("/admin/home");
        } else if ([2, 3, 4, 5, 6, 7, 8].includes(role)) {
          navigate("/user");
        } else {
          setIsVerifying(false);
        }
      } else {
        setTimeout(() => {
          setIsVerifying(false);
        }, 1000); 
      }
    };

    const timer = setTimeout(() => {
      checkAuth();
    }, 1200); 

    return () => clearTimeout(timer);
  }, [navigate]);

  if (isVerifying) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-[#0f172a]">
        <div className="relative flex items-center justify-center">
          <div className="w-20 h-20 border-4 border-indigo-500/20 border-t-indigo-500 rounded-full animate-spin"></div>
          <div className="absolute w-10 h-10 bg-indigo-500/10 rounded-full flex items-center justify-center animate-pulse">
            <div className="w-2 h-2 bg-indigo-400 rounded-full"></div>
          </div>
        </div>

        <div className="mt-8 text-center">
          <h2 className="text-white text-lg font-semibold tracking-widest uppercase">
            Verifying Identity
          </h2>
          <div className="flex items-center justify-center gap-2 mt-2">
            <span className="w-1.5 h-1.5 bg-green-500 rounded-full animate-bounce"></span>
            <p className="text-slate-400 text-sm font-medium">
              Establishing secure connection...
            </p>
          </div>
        </div>

        <div className="absolute bottom-10 opacity-30">
          <p className="text-white text-[10px] tracking-[0.3em] uppercase">
            Quotation Management System
          </p>
        </div>
      </div>
    );
  }

  return children;
};

export default AuthCheck;